import { render, staticRenderFns } from "./AnResourcesPressure.vue?vue&type=template&id=67b017b0&scoped=true&"
import script from "./AnResourcesPressure.vue?vue&type=script&lang=js&"
export * from "./AnResourcesPressure.vue?vue&type=script&lang=js&"
import style0 from "./AnResourcesPressure.vue?vue&type=style&index=0&id=67b017b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b017b0",
  null
  
)

export default component.exports